import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#D4A574] text-white hover:bg-[#C09060] focus-visible:ring-[#D4A574]',
    secondary: 'bg-gray-900 text-white hover:bg-gray-800 focus-visible:ring-gray-900',
    outline: 'border border-gray-300 bg-transparent hover:bg-gray-50 text-gray-900 focus-visible:ring-gray-500',
    ghost: 'hover:bg-gray-100 hover:text-gray-900 text-gray-600'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || isLoading} {...props} data-id="element-131">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-132" />}
      {children}
    </button>;
}